import api from "./interceptorServices"
import { API_URL } from "./ApiURL"
import { getCookie } from "../utils/cookies"

const getAuthConfig = () => {
  const token = getCookie("accesstoken")

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
}

const SaveBets = async (body) => {
  try {
    const { data } = await api.post(
      `${API_URL}bet/add`,
      body,
      getAuthConfig()
    )
    return data
  } catch (error) {
    console.log("SaveBets error:", error?.response?.data || error)
    throw error
  }
}

// get last bet id
const GetLastBetId = async () => {
  try {
    const { data } = await api.get(
      `${API_URL}bet/last-id`,
      getAuthConfig()
    )
    return data
  } catch (error) {
    console.log("GetLastBetId error:", error?.response?.data || error)
    throw error
  }
}

const GetIdleTime = async () => {
  try {
    const { data } = await api.get(`${API_URL}settings/idle-time`, getAuthConfig())
    return data
  } catch (error) {
    console.log("GetIdleTime error")
    throw error
  }
}

const CheckHotNumber = async (combination) => {
  try {
    const { data } = await api.post(
      `${API_URL}hotnumbers/check`,
      { combination },
      getAuthConfig()
    )
    return data
  } catch (error) {
    console.log("CheckHotNumber error:", error?.response?.data || error)
    throw error
  }
}

const CheckBetLimit = async (body) => {
  try {
    const { data } = await api.post(
      `${API_URL}bet/check-limit`,
      body,
      getAuthConfig()
    )
    return data
  } catch (error) {
    console.log("CheckBetLimit error:", error?.response?.data || error)
    throw error
  }
}

export {
  SaveBets,
  GetLastBetId,
  CheckBetLimit,
  CheckHotNumber,
  GetIdleTime,
}